import React from 'react';
import { Toaster } from 'react-hot-toast';
import { breakpoints, useMediaQuery } from '../utils';

export const ToastRenderer: React.FC = () => {
  const isMobile = !useMediaQuery(breakpoints.from('tablet'));
  const defaultPosition = isMobile ? 'bottom-center' : 'top-right';
  return <Toaster toastOptions={{ position: defaultPosition }} />;
};
